export default __webpack_public_path__ + "static/media/common-questions.824e969c.svg";